
const digest = '0d1122b225d2f80592cd456b6f2985b93f0cd3237e31b7a53be5116908d9c227';
const classes = {"wrapper":"_wrapper_1uzwo_1","header":"_header_1uzwo_9","date":"_date_1uzwo_20","document":"_document_1uzwo_24","options":"_options_1uzwo_27","list":"_list_1uzwo_37"};
const css = `._wrapper_1uzwo_1 {
  font-family: "Rubik", sans-serif;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: hidden;
}
._wrapper_1uzwo_1 ._header_1uzwo_9 {
  display: flex;
  flex-direction: row;
  gap: 28px;
  padding: 6px 19px;
  font-size: 14px;
  font-weight: 500;
  background: #fbfbfd !important;
  border-right: 1px solid #eaedf3;
  border-left: 1px solid #eaedf3;
}
._wrapper_1uzwo_1 ._header_1uzwo_9 ._date_1uzwo_20 {
  min-width: 150px;
  max-width: 150px;
}
._wrapper_1uzwo_1 ._header_1uzwo_9 ._document_1uzwo_24 {
  flex-grow: 1;
}
._wrapper_1uzwo_1 ._options_1uzwo_27 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
  padding: 16px 24px;
  border: 1px solid #eaedf3;
  box-shadow: inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  border-top: 0;
}
._wrapper_1uzwo_1 ._list_1uzwo_37 {
  box-shadow: inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  